'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var alertContext = require('./alertContext.js');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var AlertTitle = react.forwardRef(function AlertTitle(props, ref) {
  var styles = alertContext.useAlertStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref
  }, props, {
    className: utils.cx('chakra-alert__title', props.className),
    __css: styles.title
  }));
});
AlertTitle.displayName = 'AlertTitle';
exports.AlertTitle = AlertTitle;